import React, { ReactNode, useContext, useState } from 'react';
import { useWindowSize } from 'react-use';
import {useNavigate} from 'react-router-dom';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { dashboardPagesMenu, pageLayoutTypesPagesMenu } from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
import Icon from '../../../components/icon/Icon';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
const DefaultAside = () => {

	const navigate = useNavigate();
	const { width } = useWindowSize();
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	const [doc, setDoc] = useState(
		localStorage.getItem('facit_asideDocStatus') === 'true' || false,
	);

	const { t } = useTranslation(['translation', 'menu']);

	// Build menu dari localStorage setiap render (dinamis)
	// Format: bisa flat item atau parent dengan children array
	const storedMenu = localStorage.getItem('menu');
	const menu: any[] = storedMenu ? JSON.parse(storedMenu) : [];
	const userMenu: Record<string, any> = {};

	const iconMap: Record<string, string> = {
		'Dept Appv': 'Approval',
		'My List': 'DocumentScanner',
		'Ajuan': 'DocumentScanner',
		'Legal Queue': 'Queue',
		'Legal Draft': 'Drafts',
		'Legal Signed': 'Assignment',
		'User Management': 'Person',
		'Role Management': 'Security',
		'Dept Approval': 'VerifiedUser',
		'Branch Management': 'Business',
		'Department': 'CorporateFare',
	};

	function resolveIcon(text: string, icon?: string): string {
		return icon || iconMap[text] || 'ViewCompact';
	}

	menu.forEach((item: any) => {
		if (item.children && item.children.length > 0) {
			// Parent group — build subMenu
			const subMenu: Record<string, any> = {};
			item.children.forEach((child: any) => {
				const childPath = child.path || `/${child.id}`;
				subMenu[child.id] = {
					id: child.id,
					path: childPath,
					text: child.text,
					icon: resolveIcon(child.text, child.icon),
				};
			});
			userMenu[item.id] = {
				id: item.id,
				text: item.text,
				path: '#', // dummy — parent items use expand/collapse, not navigation
				icon: resolveIcon(item.text, item.icon),
				subMenu,
			};
		} else {
			// Leaf menu
			const menuPath = item.path || `/${item.id}`;
			userMenu[item.id] = {
				id: item.id,
				path: menuPath,
				text: item.text,
				icon: resolveIcon(item.text, item.icon),
			};
		}
	});

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			
			<AsideBody>
				{/* <Navigation menu={dashboardPagesMenu} id='aside-dashboard' /> */}
				{!doc && (
					<>
						{/* <Navigation menu={demoPagesMenu} id='aside-demo-pages' /> */}
						<Navigation menu={userMenu} id = 'test'/>
						{/* <NavigationLine /> */}
						{/* <Navigation menu={pageLayoutTypesPagesMenu} id='aside-menu' /> */}
						<NavigationLine />
						<nav>
							<div className='navigation'>
								<div className='navigation-item'>
									<span className='navigation-link navigation-link-pill'>
											{/* <span className='navigation-link-info'>
												<span className='navigation-text'>
													<Popovers
														title='Aside.tsx'
														desc={
															<code>
																src/pages/_layout/_asides/DefaultAside.tsx
															</code>
														}>
														Aside
													</Popovers>
													<code className='ps-3'>DefaultAside.tsx</code>
												</span>
											</span> */}
									</span>
								</div>
							</div>
						</nav>
					</>
				)}
				{asideStatus && doc && <div className='p-4'>Documentation</div>}
			</AsideBody>
			<AsideFoot>
				<nav aria-label='aside-bottom-menu'>
					<div className='navigation'>
						{/* <div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() => {
								localStorage.setItem('facit_asideDocStatus', String(!doc));
								setDoc(!doc);
							}}
							data-tour='documentation'>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon
										icon={doc ? 'ToggleOn' : 'ToggleOff'}
										color={doc ? 'success' : undefined}
										className='navigation-icon'
									/>
									<span className='navigation-text'>
										{t('menu:Documentation') as ReactNode}
									</span>
								</span>
								<span className='navigation-link-extra'>
									<Icon
										icon='Circle'
										className={classNames(
											'navigation-notification',
											'text-success',
											'animate__animated animate__heartBeat animate__infinite animate__slower',
										)}
									/>
								</span>
							</span>
						</div> */}
					</div>
				</nav>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
